"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hydrationHelpers_1 = require("../hydrationHelpers");
var SignatureSlot_1 = require("../EsignComponents/SignatureSlot/SignatureSlot");
var DIProvider_1 = __importStar(require("@CommonFrontend/DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var inversify_react_1 = require("inversify-react");
var AcceptersDataStore_1 = require("@CommonFrontend/AcceptFlow/AcceptersDataStore");
var mobx_react_1 = require("mobx-react");
var AcceptFlowGlobalStore_1 = __importDefault(require("@CommonFrontend/AcceptFlow/AcceptFlowGlobalStore"));
var styles = __importStar(require("./Initials.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var dynamic_1 = require("@vanilla-extract/dynamic");
var classnames_1 = __importDefault(require("classnames"));
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var InitialsWidget = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var attributes = _a.attributes, isPrintMode = _a.isPrintMode;
    var acceptStore = (0, inversify_react_1.useInjection)("acceptersDataStore");
    var handleChangeSignature = function (data, index) {
        acceptStore.updateSlotInitials(index, data.signature);
    };
    var handleClearSignature = function (index) {
        acceptStore.clearSlot(index);
    };
    var storeIndex = AcceptFlowGlobalStore_1.default.getInstance().getAllDataStores().indexOf(acceptStore);
    var useMaxCol = isPrintMode;
    var maxColumnCount = acceptStore.accepterSlots.length > 2 ? "3" : "2";
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)("initials-widget", attributes === null || attributes === void 0 ? void 0 : attributes.className, tokens_1.lightTheme), style: (0, dynamic_1.assignInlineVars)((_b = {}, _b[styles.maxColumnCount] = maxColumnCount, _b)), contentEditable: false }),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", wrap: true, className: styles.container({ maxCol: useMaxCol }) }, acceptStore.accepterSlots.map(function (accepter, index) {
            var _a;
            return (react_1.default.createElement("div", { id: "agreement-initials-signature-".concat(storeIndex, "-").concat(index), key: index, className: styles.slotContainer },
                react_1.default.createElement(SignatureSlot_1.SignatureSlot, { name: accepter.name, isMultiAccept: acceptStore.accepterSlots.length > 1, hasPrefilledName: acceptStore.hasPrefilledName(index), isPrintMode: isPrintMode, data: (_a = accepter.initials) !== null && _a !== void 0 ? _a : null, onClear: function () { return handleClearSignature(index); }, onChange: function (data) { return handleChangeSignature(data, index); }, type: SignatureSlot_1.SlotType.Initials, isEditable: !accepter.isAccepted && !AcceptFlowGlobalStore_1.default.getInstance().isSlotLockedInAnyStore(index), isCritical: accepter.isCritical })));
        }))));
});
var WrappedInitialsWidget = function (_a) {
    var attributes = _a.attributes, di = _a.di, isPrintMode = _a.isPrintMode;
    var isClientSide = typeof document !== "undefined";
    if (!isClientSide) {
        return null;
    }
    var container = new inversify_1.Container({ skipBaseClassChecks: true });
    var acceptersDataStore = new AcceptersDataStore_1.AcceptersDataStore(di.get("$rootScope"));
    container.bind("acceptersDataStore").toConstantValue(acceptersDataStore);
    AcceptFlowGlobalStore_1.default.getInstance().registerDataStore(acceptersDataStore);
    return (react_1.default.createElement(DIProvider_1.RootDIProvider, { di: di },
        react_1.default.createElement(DIProvider_1.default, { container: function () { return container; } },
            react_1.default.createElement(InitialsWidget, { attributes: attributes, isPrintMode: isPrintMode }))));
};
exports.default = (0, hydrationHelpers_1.withHydrationHost)(WrappedInitialsWidget, { componentName: "InitialsWidget" });
